import { Columns, Column } from './styles'

export default {
  Columns,
  Column,
}
